var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.781248 4.06249H17.3265L14.5857 1.335C14.2799 1.03062 14.2787 0.535973 14.5831 0.230153C14.8874 -0.0757059 15.3821 -0.0768384 15.688 0.227497L19.7701 4.28999C19.7704 4.29023 19.7706 4.2905 19.7708 4.29074C20.0759 4.59511 20.0769 5.09136 19.7709 5.39675C19.7706 5.39699 19.7705 5.39726 19.7702 5.39749L15.688 9.45999C15.3823 9.76429 14.8876 9.76323 14.5832 9.45733C14.2788 9.15151 14.2799 8.65687 14.5858 8.35249L17.3265 5.62499H0.781248C0.349764 5.62499 0 5.27523 0 4.84374C0 4.41226 0.349764 4.06249 0.781248 4.06249Z",
    fill: "#979C9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGrayIcon);
export default __webpack_public_path__ + "static/media/ArrowRightGrayIcon.0171b7d8.svg";
export { ForwardRef as ReactComponent };